function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import clsx from "clsx";
import React from "react";
import { BlockBackgroundShape } from "./blocks/BlockBackgroundShape";
export default function Intro(param) {
    var title = param.title, lead = param.lead, color = param.color, _param_size = param.size, size = _param_size === void 0 ? "medium" : _param_size, author = param.author, formattedDate = param.formattedDate, backgroundShape = param.backgroundShape;
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("container-content-wrapper mt-5 md:mt-8", {
            "text-center": size === "small"
        })
    }, backgroundShape && backgroundShape.shape !== "None" ? /*#__PURE__*/ React.createElement(BlockBackgroundShape, _extends({}, backgroundShape)) : null, /*#__PURE__*/ React.createElement("h1", {
        className: clsx({
            "lg:pr-[25%]": size !== "small",
            "text-lg leading-7 md:text-2xl md:leading-2xl mb-6": size === "small",
            "text-xl leading-8 md:text-3xl md:leading-3xl mb-6 md:mb-10": size === "medium",
            "text-2xl leading-2xl md:text-4xl md:leading-4xl mb-8 md:mb-12": size === "large",
            "text-turquoise-500": color === "turquoise",
            "text-purple": color === "purple",
            headlineBig: size === "large"
        })
    }, title), author && formattedDate ? /*#__PURE__*/ React.createElement("div", {
        className: "text-turquoise-600 mb-5 md:mb-8"
    }, author, " / ", formattedDate) : null, /*#__PURE__*/ React.createElement("div", {
        className: "prose max-w-full"
    }, /*#__PURE__*/ React.createElement("p", {
        className: clsx({
            "mx-auto text-center": size === "small"
        })
    }, lead)))));
}
